// extracted by mini-css-extract-plugin
export default {"Main":"RepairItem_Main__r496M","zoom":"RepairItem_zoom__CPs4I"};